import React from 'react'
import { ReactComponent as SadEmoji } from 'assets/svg/emojis/emoji-sad.svg'
import { NoAssetsTitle, RedirectText } from './styled'

const Noassets = ({ message }: { message: string }) => {
  return (
    <div style={{ textAlign: 'center', fontFamily: 'Rubik' }}>
      <SadEmoji />
      <NoAssetsTitle>{message}</NoAssetsTitle>
      <RedirectText>
        Go to boxycats website to bid and sell NFTs.
        <a href="https://boxycats.web.app" target="_blank" rel="noreferrer">
          Click Here
        </a>
      </RedirectText>
    </div>
  )
}

export default Noassets
